'use client';

import React from 'react';
import Footer from '../components/Footer';
import Introduce from './Introduce';
import Header from '../components/Header';

import Bottom from './Bottom';
import KeyFeatures from './keyFeatures';
import Solutions from './solutions';
import CustomerBenefit from './customerBenefit';

export default function Home() {
  return (
    <div className="flex flex-col justify-center w-full mx-auto">
      <Header />
      <div className="flex flex-col z-10">
        <Introduce />
        <KeyFeatures />
        <Solutions />
        <CustomerBenefit />
        <Bottom />
        <Footer />
      </div>
    </div>
  );
}
